// Constructor
function Scenario(app, $container, renderer) {
  this.app = app;
  this.$container = $container;
  this.renderer = renderer;

  this.preloaded = false;
  this.started = false;
  this.introPlayedOnce = false;

  // this.dragStartPos = {
  // 	cursorX: 0,
  // 	cameraX: 0,
  // }
  // this.dragTargetX = 0;
  // this.dragSpeedFactor = 1;
  this.impetus = false;
  this.impetusPaused = false;

  this.introToGameTimeline = false;
  this.timeline = false;
  this.autoZoomToHouseDuration = 1500;

  this.renderEnabled = false;

  this.baseSceneBlur = 0.0;

  this.referenceHeight = 1080;
  this.referenceImageOriginalDimensions = {
    w: 0,
    h: 0
  };

  this.textureLoader = new THREE.TextureLoader();

  this.scene = new THREE.Scene();
  this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 10000);
  this.camera.position.z = 1000;

  // Init render target texture
  this.sea1ShaderMaterial = false;
  // this.seaOffScreenRenderer = false;

  this.lastScrollMillis = millis();
  this.checkScrollInterval = false;

  this.composer = new THREE.EffectComposer(this.renderer);
  this.composer.addPass(new THREE.RenderPass(this.scene, this.camera));

  this.hblur = new THREE.ShaderPass(THREE.GausianBlurShader);
  this.hblur.uniforms.resolution.value = window.innerWidth;
  this.hblur.uniforms.radius.value = 0.0; // intensity
  this.hblur.uniforms.direction.value = new THREE.Vector2(1.0, 0.0);

  this.composer.addPass(this.hblur);

  this.vblur = new THREE.ShaderPass(THREE.GausianBlurShader);
  this.vblur.uniforms.resolution.value = window.innerHeight;
  this.vblur.uniforms.radius.value = 0.0; // intensity
  this.vblur.uniforms.direction.value = new THREE.Vector2(0.0, 1.0);

  this.vblur.renderToScreen = true;
  this.composer.addPass(this.vblur);

  // Call to init() is made by parent.
}

Scenario.prototype.init = function () {

  console.log("Scenario init.")


};

// Load JSON and init game
Scenario.prototype.loadShaders = function () {

  return new Promise($.proxy(function (resolve, reject) {

    var shaderLoader1 = $.ajax({
      url: "shaders/seaShader.glsl?v=" + OUAS_VERSION,
      cache: false,
      beforeSend: function (xhr) {
        xhr.overrideMimeType("text/plain; charset=utf-8");
      }
    }).done($.proxy(function (data) {
      this.shader1 = data;
    }, this)).fail(function () {
      alert("Shader file not found. Please add the data file and restart the app.");
    });

    var shaderLoader2 = $.ajax({
      url: "shaders/vertex.glsl?v=" + OUAS_VERSION,
      cache: false,
      beforeSend: function (xhr) {
        xhr.overrideMimeType("text/plain; charset=utf-8");
      }
    }).done($.proxy(function (data) {
      this.shaderVertex = data;
    }, this)).fail(function () {
      alert("Shader file not found. Please add the data file and restart the app.");
    });

    // Wait for all
    Promise.all([
      shaderLoader1.promise(),
      shaderLoader2.promise(),
    ]).then($.proxy(function () {
      resolve()
    }, this)).catch($.proxy(function () {
      reject()
    }, this));

  }, this));

};


// must resolve/reject
Scenario.prototype.preload = function (resolve, reject) {

  if (this.preloaded) {
    console.log("Scenario already preloaded.")
    resolve();
    return;
  }

  this.impetus = new Impetus({
    source: this.renderer.domElement,
    boundX: [-1, 1],
    boundY: [-1, 1],
    update: $.proxy(this.dragUpdate, this)
  });


  // preload and build things
  this.loadShaders().then($.proxy(function () {
    // Build 3D scene
    this.buildScene($.proxy(function () {
      this.setDefaultSceneStyles();

      this.defineIntroAnimation();

      this.defineTimeline();
      this.setScroll();

      // Resolve Promise
      console.log("Scenario init completed.")
      this.preloaded = true;

      // Force render 1 frame to prevent jittering
      // this.renderer.render(this.scene, this.camera);
      this.composer.render(this.scene, this.camera);

      resolve();

    }, this));
  }, this)).catch($.proxy(function (e) {
    console.error(e);
    var reason = new Error("Couldn't load shaders correctly.");
    reject(reason);
  }, this));

}


Scenario.prototype.beforePreloaderFadeIn = function () {
  console.log("Scenario: Before preloader fadein");
  this.stop();
}

Scenario.prototype.afterPreloaderFadeIn = function () {
  console.log("Scenario: After preloader fadein");

  this.disableRendering();

  this.unlinkScrollAndTimeline();

  $("#game-1").addClass("hidden");
  $("#continue-to-scroll").removeClass("shown");

  // force scroll back up
  $('html, body').animate({
    scrollTop: 0
  }, 10);
}

Scenario.prototype.beforePreloaderFadeOut = function () {
  console.log("Scenario: Before preloader fadeout");

  $("#game-1").removeClass("hidden");

  this.enableRendering();
  this.startTime = millis();

  this.linkScrollAndTimeline();

  // Go to the end of intro if is set as played
  if (this.introPlayedOnce) {
    this.introToGameTimeline.progress(1)
  }

  this.reset();
}

Scenario.prototype.afterPreloaderFadeOut = function () {
  console.log("Scenario: After preloader fadeout");

  this.app.audio.fadeOutAllTracks();
  this.app.audio.play("audio/OUAS1.mp3", true);

  this.lastScrollMillis = millis();

  if (this.introPlayedOnce) {
    this.start();

  } else {
    this.introToGameTimeline.eventCallback("onComplete", function () {
      this.start();
    }, [], this);

    // TODO To remove, used for faster developpement
    // this.introToGameTimeline.timeScale(20);

    // Trigger aniamtion in
    this.introToGameTimeline.play();

    this.introPlayedOnce = true;
  }

}

Scenario.prototype.start = function () {
  this.started = true;
  this.enableDrag();
  this.app.enableScroll();

  if (this.checkScrollInterval) {
    clearInterval(this.checkScrollInterval);
    this.checkScrollInterval = false;
  }

  this.lastScrollMillis = millis();
  this.checkScrollInterval = setInterval($.proxy(this.scrollCheck, this), 250);
}

Scenario.prototype.stop = function () {
  this.started = false;
  this.disableDrag();
  this.app.disableScroll();

  if (this.checkScrollInterval) {
    clearInterval(this.checkScrollInterval);
    this.checkScrollInterval = false;
  }
}

Scenario.prototype.scrollCheck = function () {

  if (this.renderEnabled == false) {
    return;
  }

  // If we reach the end of the gauge, show continue to scroll faster
  var cursorTop = $("#screen-1-progression-line-container .cursor")[0].style.top;

  // Check if gauge is at 100%
  if ((millis() - this.lastScrollMillis > 2000) && cursorTop == "100%" && (this.timeline.time() < this.timeline.duration())) {
    // Show invitation to scroll
    $("#continue-to-scroll").addClass("shown");
  } else if ((millis() - this.lastScrollMillis > 6000) && (this.timeline.time() < this.timeline.duration())) {
    // Show invitation to scroll
    $("#continue-to-scroll").addClass("shown");
  } else {
    // Hide invitation to scroll
    $("#continue-to-scroll").removeClass("shown");
  }

}

Scenario.prototype.buildScene = function (callback) {
  // TODO: load things correctly, maybe with a JSON?

  var texturesToLoad = 0;
  var texturesLoaded = 0;

  this.globalSceneGroup = new THREE.Group();
  this.globalSceneGroup.renderOrder = 0;
  this.scene.add(this.globalSceneGroup);

  this.scene1Group = new THREE.Group();
  this.scene1Group.renderOrder = 1;
  this.globalSceneGroup.add(this.scene1Group);

  this.scene1OverGroup = new THREE.Group();
  this.scene1OverGroup.renderOrder = 3;
  this.globalSceneGroup.add(this.scene1OverGroup);

  // Init sea material
  this.sea1ShaderMaterial = new THREE.ShaderMaterial({
    uniforms: {
      time: {value: 0.0},
      resolution: {value: new THREE.Vector2(1, 1)},
      tTexture1: {value: false},
      tTexture2: {value: false},
      tTexture3: {value: false},
      effect: {value: 0},
      fadeout: {value: 0.0},
      displacementModifier: {value: 1.0},
      verticalWavesReflectionSpeed: {value: 1.15},
    },
    vertexShader: this.shaderVertex,
    fragmentShader: this.shader1,
    transparent: true
  });

  // Init sea offscreen renderer
  // this.seaOffScreenRenderer = new OffScreenRender(1200, 563, 1, false);
  // this.seaOffScreenRenderer.setShader(this.sea1ShaderMaterial);

  // Screen 1 montains
  texturesToLoad++;
  this.textureLoader.load(
    'images/scenario/v2/1SHIMON_1LARGE_BG_MOUNTAIN.jpg',
    $.proxy(function (texture) {
      // console.log("s1Mountains loaded");
      var material = new THREE.MeshBasicMaterial({map: texture, transparent: true});
      var geometry = new THREE.PlaneGeometry(texture.image.width, texture.image.height);
      this.s1Mountains = new THREE.Mesh(geometry, material);
      this.s1Mountains.position.set(0, (this.referenceHeight - texture.image.height) / 2, 0);
      this.s1Mountains.renderOrder = 1;
      this.scene1Group.add(this.s1Mountains);

      this.referenceImageOriginalDimensions.w = texture.image.width;
      this.referenceImageOriginalDimensions.h = texture.image.height;

      texturesLoaded++;
      this.app.preloader.update(texturesLoaded / texturesToLoad);
      if (texturesLoaded == texturesToLoad) {
        callback();
      }
    }, this)
  );

  // Screen 1 water
  texturesToLoad++;
  this.textureLoader.load(
    'images/scenario/v2/1SHIMON_1LARGE_SEA_NO_WAVES.jpg',
    $.proxy(function (texture) {
      // console.log("s1Sea loaded");

      // Set shader material properties material
      this.sea1ShaderMaterial.uniforms.resolution.value = new THREE.Vector2(texture.image.width, texture.image.height)
      this.sea1ShaderMaterial.uniforms.tTexture1.value = texture

      var geometry = new THREE.PlaneGeometry(texture.image.width, texture.image.height);
      var material = this.sea1ShaderMaterial;
      // var material = new THREE.MeshBasicMaterial({map: texture, transparent: true});
      // var material = this.seaOffScreenRenderer.createOutputMaterial();
      this.s1Sea = new THREE.Mesh(geometry, material);
      this.s1Sea.position.set(0, -(this.referenceHeight - texture.image.height) / 2, 0);
      this.scene1OverGroup.add(this.s1Sea);
      this.s1Sea.renderOrder = 2;

      texturesLoaded++;
      this.app.preloader.update(texturesLoaded / texturesToLoad);
      if (texturesLoaded == texturesToLoad) {
        callback();
      }
    }, this)
  );


  // Screen 2

  this.scene2UnderGroup = new THREE.Group();
  this.scene2UnderGroup.renderOrder = -1;
  this.globalSceneGroup.add(this.scene2UnderGroup);

  this.scene2OverGroup = new THREE.Group();
  this.scene2OverGroup.renderOrder = 2;
  this.globalSceneGroup.add(this.scene2OverGroup);

  texturesToLoad++;
  this.textureLoader.load(
    'images/scenario/v2/1SHIMON_2LARGE_BG_MOUNTAIN.jpg',
    $.proxy(function (texture) {
      // console.log("s2Mountains loaded");
      var material = new THREE.MeshBasicMaterial({map: texture, transparent: true});
      var geometry = new THREE.PlaneGeometry(texture.image.width, texture.image.height);
      this.s2Mountains = new THREE.Mesh(geometry, material);
      this.s2Mountains.position.set(0, (this.referenceHeight - texture.image.height) / 2, 0);
      this.s2Mountains.renderOrder = 0;
      this.scene1Group.add(this.s2Mountains);


      texturesLoaded++;
      this.app.preloader.update(texturesLoaded / texturesToLoad);
      if (texturesLoaded == texturesToLoad) {
        callback();
      }
    }, this)
  );

  texturesToLoad++;
  this.textureLoader.load(
    'images/scenario/v2/1SHIMON_2LARGE_HOUSE.png',
    $.proxy(function (texture) {
      // console.log("s2House loaded");
      var material = new THREE.MeshBasicMaterial({map: texture, transparent: true});
      var geometry = new THREE.PlaneGeometry(texture.image.width, texture.image.height);
      this.s2House = new THREE.Mesh(geometry, material);
      this.s2House.position.set(0, -150, 0);
      this.s2House.renderOrder = 1;
      this.scene2OverGroup.add(this.s2House);

      texturesLoaded++;
      this.app.preloader.update(texturesLoaded / texturesToLoad);
      if (texturesLoaded == texturesToLoad) {
        callback();
      }
    }, this)
  );

  texturesToLoad++;
  this.textureLoader.load(
    'images/scenario/v2/1SHIMON_3CLOSEUP_HOUSE_GARDEN.png',
    $.proxy(function (texture) {
      // console.log("s3House loaded");
      var material = new THREE.MeshBasicMaterial({map: texture, transparent: true});
      var geometry = new THREE.PlaneGeometry(texture.image.width, texture.image.height);
      this.s3House = new THREE.Mesh(geometry, material);
      this.s3House.position.set(2, -164, 0);
      this.s3House.renderOrder = 2;
      this.scene2OverGroup.add(this.s3House);

      texturesLoaded++;
      this.app.preloader.update(texturesLoaded / texturesToLoad);
      if (texturesLoaded == texturesToLoad) {
        callback();
      }
    }, this)
  );

  texturesToLoad++;
  this.textureLoader.load(
    'images/scenario/v2/1SHIMON_2LARGE_GROUND.jpg',
    $.proxy(function (texture) {
      // console.log("s2Ground loaded");
      var material = new THREE.MeshBasicMaterial({map: texture, transparent: true});
      var geometry = new THREE.PlaneGeometry(texture.image.width, texture.image.height);
      this.s2Ground = new THREE.Mesh(geometry, material);
      this.s2Ground.position.set(0, -(this.referenceHeight - texture.image.height) / 2, 0);
      this.s2Ground.renderOrder = 1;
      this.scene2UnderGroup.add(this.s2Ground);

      texturesLoaded++;
      this.app.preloader.update(texturesLoaded / texturesToLoad);
      if (texturesLoaded == texturesToLoad) {
        callback();
      }
    }, this)
  );

  texturesToLoad++;
  this.textureLoader.load(
    'images/scenario/v2/1SHIMON_2LARGE_GROUND_SALT.jpg',
    $.proxy(function (texture) {
      // console.log("s2GroundSalt loaded");
      var material = new THREE.MeshBasicMaterial({map: texture, transparent: true});
      var geometry = new THREE.PlaneGeometry(texture.image.width, texture.image.height);
      this.s2GroundSalt = new THREE.Mesh(geometry, material);
      this.s2GroundSalt.position.set(0, -(this.referenceHeight - texture.image.height) / 2, 0);
      this.s2GroundSalt.renderOrder = 0;
      this.scene2OverGroup.add(this.s2GroundSalt);

      texturesLoaded++;
      this.app.preloader.update(texturesLoaded / texturesToLoad);
      if (texturesLoaded == texturesToLoad) {
        callback();
      }
    }, this)
  );


  texturesToLoad++;
  this.textureLoader.load(
    'images/sea_mask.png',
    $.proxy(function (texture) {
      // console.log("sea_mask loaded");
      this.sea1ShaderMaterial.uniforms.tTexture2.value = texture;
      this.sea1ShaderMaterial.uniforms.tTexture2.value.wrapS = THREE.RepeatWrapping

      texturesLoaded++;
      this.app.preloader.update(texturesLoaded / texturesToLoad);
      if (texturesLoaded == texturesToLoad) {
        callback();
      }
    }, this)
  );

  texturesToLoad++;
  this.textureLoader.load(
    'images/scenario/v2/1SHIMON_1LARGE_SEA_ONLY_WAVES.jpg',
    $.proxy(function (texture) {
      // console.log("1SHIMON_1LARGE_SEA_ONLY_WAVES loaded");
      this.sea1ShaderMaterial.uniforms.tTexture3.value = texture;
      this.sea1ShaderMaterial.uniforms.tTexture3.value.wrapT = THREE.RepeatWrapping

      texturesLoaded++;
      this.app.preloader.update(texturesLoaded / texturesToLoad);
      if (texturesLoaded == texturesToLoad) {
        callback();
      }
    }, this)
  );

  // Screen 3

  this.scene3UnderGroup = new THREE.Group();
  this.scene3UnderGroup.renderOrder = -2;
  this.globalSceneGroup.add(this.scene3UnderGroup);

  // this.scene3OverGroup = new THREE.Group();
  // this.scene3OverGroup.renderOrder = 4;
  // this.scene.add(this.scene3OverGroup);

  texturesToLoad++;
  this.textureLoader.load(
    'images/scenario/v2/1SHIMON_3CLOSEUP_BG_SKY.jpg',
    $.proxy(function (texture) {
      // console.log("s3Sky loaded");
      var material = new THREE.MeshBasicMaterial({map: texture, transparent: true});
      var geometry = new THREE.PlaneGeometry(texture.image.width, texture.image.height);
      this.s3Sky = new THREE.Mesh(geometry, material);
      this.s3Sky.position.set(0, (this.referenceHeight - texture.image.height) / 2, 0);
      this.s3Sky.renderOrder = 0;
      this.scene3UnderGroup.add(this.s3Sky);

      texturesLoaded++;
      this.app.preloader.update(texturesLoaded / texturesToLoad);
      if (texturesLoaded == texturesToLoad) {
        callback();
      }
    }, this)
  );

  texturesToLoad++;
  this.textureLoader.load(
    'images/scenario/v2/1SHIMON_3CLOSEUP_BG_MOUNTAIN.png',
    $.proxy(function (texture) {
      // console.log("s3Montains loaded");
      var material = new THREE.MeshBasicMaterial({map: texture, transparent: true});
      var geometry = new THREE.PlaneGeometry(texture.image.width, texture.image.height);
      this.s3Montains = new THREE.Mesh(geometry, material);
      this.s3Montains.position.set(0, -(this.referenceHeight - texture.image.height) / 2, 0);
      this.s3Montains.renderOrder = 1;
      this.scene3UnderGroup.add(this.s3Montains);

      texturesLoaded++;
      this.app.preloader.update(texturesLoaded / texturesToLoad);
      if (texturesLoaded == texturesToLoad) {
        callback();
      }
    }, this)
  );


  this.scene4OverGroup = new THREE.Group();
  this.scene4OverGroup.renderOrder = 4;
  this.globalSceneGroup.add(this.scene4OverGroup);

  texturesToLoad++;
  this.textureLoader.load(
    'images/scenario/v2/1SHIMON_3CLOSEUP_HOLE_Layer1.png',
    $.proxy(function (texture) {
      // console.log("s3House loaded");
      var material = new THREE.MeshBasicMaterial({map: texture, transparent: true});
      var geometry = new THREE.PlaneGeometry(texture.image.width, texture.image.height);
      this.s4HoleLayer1 = new THREE.Mesh(geometry, material);
      this.s4HoleLayer1.position.set(0, -(this.referenceHeight - texture.image.height) / 2, 0);
      this.s4HoleLayer1.renderOrder = 0;
      this.scene4OverGroup.add(this.s4HoleLayer1);

      texturesLoaded++;
      this.app.preloader.update(texturesLoaded / texturesToLoad);
      if (texturesLoaded == texturesToLoad) {
        callback();
      }
    }, this)
  );

  texturesToLoad++;
  this.textureLoader.load(
    'images/scenario/v2/1SHIMON_3CLOSEUP_HOLE_Layer2.png',
    $.proxy(function (texture) {
      // console.log("s3House loaded");
      var material = new THREE.MeshBasicMaterial({map: texture, transparent: true});
      var geometry = new THREE.PlaneGeometry(texture.image.width, texture.image.height);
      this.s4HoleLayer2 = new THREE.Mesh(geometry, material);
      this.s4HoleLayer2.position.set(0, -(this.referenceHeight - texture.image.height) / 2, 0);
      this.s4HoleLayer2.renderOrder = 1;
      this.scene4OverGroup.add(this.s4HoleLayer2);

      texturesLoaded++;
      this.app.preloader.update(texturesLoaded / texturesToLoad);
      if (texturesLoaded == texturesToLoad) {
        callback();
      }
    }, this)
  );

  texturesToLoad++;
  this.textureLoader.load(
    'images/scenario/v2/1SHIMON_3CLOSEUP_HOLE_Layer3.png',
    $.proxy(function (texture) {
      // console.log("s3House loaded");
      var material = new THREE.MeshBasicMaterial({map: texture, transparent: true});
      var geometry = new THREE.PlaneGeometry(texture.image.width, texture.image.height);
      this.s4HoleLayer3 = new THREE.Mesh(geometry, material);
      this.s4HoleLayer3.position.set(0, -(this.referenceHeight - texture.image.height) / 2, 0);
      this.s4HoleLayer3.renderOrder = 2;
      this.scene4OverGroup.add(this.s4HoleLayer3);

      texturesLoaded++;
      this.app.preloader.update(texturesLoaded / texturesToLoad);
      if (texturesLoaded == texturesToLoad) {
        callback();
      }
    }, this)
  );

  texturesToLoad++;
  this.textureLoader.load(
    'images/scenario/v2/1SHIMON_3CLOSEUP_HOLE_Layer4.png',
    $.proxy(function (texture) {
      // console.log("s3House loaded");
      var material = new THREE.MeshBasicMaterial({map: texture, transparent: true});
      var geometry = new THREE.PlaneGeometry(texture.image.width, texture.image.height);
      this.s4HoleLayer4 = new THREE.Mesh(geometry, material);
      this.s4HoleLayer4.position.set(0, -(this.referenceHeight - texture.image.height) / 2, 0);
      this.s4HoleLayer4.renderOrder = 3;
      this.scene4OverGroup.add(this.s4HoleLayer4);

      texturesLoaded++;
      this.app.preloader.update(texturesLoaded / texturesToLoad);
      if (texturesLoaded == texturesToLoad) {
        callback();
      }
    }, this)
  );

  texturesToLoad++;
  this.textureLoader.load(
    'images/scenario/v2/1SHIMON_3CLOSEUP_HOLE_Layer5.png',
    $.proxy(function (texture) {
      // console.log("s3House loaded");
      var material = new THREE.MeshBasicMaterial({map: texture, transparent: true});
      var geometry = new THREE.PlaneGeometry(texture.image.width, texture.image.height);
      this.s4HoleLayer5 = new THREE.Mesh(geometry, material);
      this.s4HoleLayer5.position.set(0, -(this.referenceHeight - texture.image.height) / 2, 0);
      this.s4HoleLayer5.renderOrder = 4;
      this.scene4OverGroup.add(this.s4HoleLayer5);

      texturesLoaded++;
      this.app.preloader.update(texturesLoaded / texturesToLoad);
      if (texturesLoaded == texturesToLoad) {
        callback();
      }
    }, this)
  );
}

Scenario.prototype.setDefaultSceneStyles = function () {

  // Set default styles
  // new TweenMax.set(this.s2Mountains.material, {opacity: 0});
  // new TweenMax.set(this.s2Ground.material, {opacity: 0});
  this.s2GroundSalt.material.opacity = 0;

  this.s2House.material.opacity = 0;
  this.s3House.material.opacity = 0;
  this.s3House.scale.set(0.08, 0.08, 1);

  this.s4HoleLayer1.material.opacity = 0;
  this.s4HoleLayer2.material.opacity = 0;
  this.s4HoleLayer3.material.opacity = 0;
  this.s4HoleLayer4.material.opacity = 0;
  this.s4HoleLayer5.material.opacity = 0;

  new TweenMax.set($("#screen-3-text-container"), {autoAlpha: 0});

}

Scenario.prototype.enableDrag = function () {
  if (this.impetus) {
    this.impetus.resume();
    this.impetus.setValues(this.camera.position.x, this.camera.position.y);
    this.impetusPaused = false;
    $("#canvas-wrapper").removeClass("cursor-default");
  }
  // $(this.renderer.domElement).off("mousedown")
  // 	.on("mousedown", $.proxy(this.startDrag, this));
}

Scenario.prototype.disableDrag = function () {
  if (this.impetus) {
    this.impetus.pause();
    this.impetusPaused = true;
    $("#canvas-wrapper").addClass("cursor-default");
  }
  // $(this.renderer.domElement).off("mousedown");
}

Scenario.prototype.dragUpdate = function (x, y) {
  if (!this.renderEnabled) {
    return;
  }

  if (!this.impetusPaused) {
    // Find values
    var availableOnEachSide = (this.referenceImageOriginalDimensions.w - window.visibleWidthAtZDepth(0, this.camera)) / 2;
    var newPosX = -Math.max(-availableOnEachSide, Math.min(availableOnEachSide, x));

    // Update positions
    this.camera.position.x = newPosX;
  }

  new TweenMax.set($(".movable"), {x: -(this.camera.position.x * 0.6)});
  // new TweenMax.set(this.camera.position, {x: this.camera.position.x});
}

// Scenario.prototype.startDrag = function (e) {
//
// 	if (!this.renderEnabled) {
// 		return;
// 	}
//
// 	console.log("start drag");
//
// 	this.dragStartPos = {
// 		cursorX: e.originalEvent.clientX,
// 		cameraX: this.camera.position.x,
// 	}
//
// 	// we use the window to make it work correctly if the mouse exits the window while dragging
// 	$(window).off("mousemove").off("mouseup")
// 		.on("mousemove", $.proxy(this.dragMove, this))
// 		.on("mouseup", $.proxy(this.stopDrag, this));
// }
//
// Scenario.prototype.dragMove = function (e) {
// 	if (!this.renderEnabled) {
// 		return;
// 	}
//
// 	var xDiff = this.dragStartPos.cursorX - e.originalEvent.clientX;
//
// 	var availableOnEachSide = (this.referenceImageOriginalDimensions.w - window.visibleWidthAtZDepth(0, this.camera)) / 2;
// 	var newPosX = Math.max(-availableOnEachSide, Math.min(availableOnEachSide, this.dragStartPos.cameraX + (xDiff * this.dragSpeedFactor)));
//
// 	this.dragTargetX = newPosX;
//
//
// 	// this.camera.position.x = newPosX;
//
// 	// move the interface
// 	// TODO: the interface is moving at a different speed than the background.
// 	//  I adjusted it using the *0.6 value but it is not right and does not behave the same for every screen size
// 	//  Maybe find a way to move it correctly.
// 	//  Don't forget to change it in the resize function too
// 	// new TweenMax.set($(".movable"), {x: -(	this.camera.position.x * 0.6)});
// }

// Scenario.prototype.stopDrag = function (e) {
//
// 	if (!this.renderEnabled) {
// 		return;
// 	}
//
// 	console.log("stop drag");
// 	$(window).off("mousemove").off("mouseup");
// }

Scenario.prototype.resize = function () {
  this.camera.aspect = window.innerWidth / window.innerHeight;

  // var dist = Math.abs(this.camera.position.z - this.mountains.position.z);
  var dist = Math.abs(this.camera.position.z); // use the camera position directly, because objects are at position 0
  let height = this.referenceHeight // desired height to fit
  this.camera.fov = 2 * Math.atan(height / (2 * dist)) * (180 / Math.PI);
  this.camera.updateProjectionMatrix();

  // this.camera.updateProjectionMatrix();
  this.renderer.setSize(window.innerWidth, window.innerHeight);

  this.hblur.uniforms.resolution.value = window.innerWidth;
  this.vblur.uniforms.resolution.value = window.innerHeight;

  if (this.app.scrollScene) {
    this.app.scrollScene.duration($("body").height() - window.innerHeight);
  }

  // Replace the camera if it is out of bounds
  var availableOnEachSide = (this.referenceImageOriginalDimensions.w - window.visibleWidthAtZDepth(0, this.camera)) / 2;
  var newPosX = Math.max(-availableOnEachSide, Math.min(availableOnEachSide, this.camera.position.x));
  // this.camera.position.x = newPosX;
  // this.impetus.setValues(newPosX, 0);
  this.impetus.setBoundX([-availableOnEachSide, availableOnEachSide]);

  // move the interface
  new TweenMax.set($(".movable"), {x: -(newPosX * 0.6)});
}

Scenario.prototype.animate = function () {
  if (!this.renderEnabled) {
    return;
  }

  // this.seaOffScreenRenderer.render(this.renderer);

  // this.sea1ShaderMaterial.uniforms.time.value = 0.01;
  this.sea1ShaderMaterial.uniforms.time.value = (millis() - this.startTime) / 10000;

  // Update camera with tween
  // if (Math.abs(this.dragTargetX - this.camera.position.x) > 0.1) {
  // 	this.camera.position.x += (this.dragTargetX - this.camera.position.x) * 0.2;
  // 	new TweenMax.set($(".movable"), {x: -(this.camera.position.x * 0.6)});
  // }

  // Request adnimation frame at 30 FPS
  setTimeout($.proxy(function () {
    requestAnimationFrame($.proxy(this.animate, this));
  }, this), 1000 / 30);

  // this.renderer.render(this.scene, this.camera);
  this.composer.render(this.scene, this.camera);
}

Scenario.prototype.enableRendering = function () {
  if (this.renderEnabled) {
    return;
  }
  this.renderEnabled = true;
  this.animate();
}

Scenario.prototype.disableRendering = function () {
  this.renderEnabled = false;
}

Scenario.prototype.defineIntroAnimation = function () {

  // TO GAME
  this.introToGameTimeline = new TimelineMax({paused: true});

  this.introToGameTimeline.addCallback(function () {
    $("body").addClass("intro-shown");
  });

  this.vblur.uniforms.radius.value = this.hblur.uniforms.radius.value = this.baseSceneBlur;

  this.introToGameTimeline.set($("#intro"), {
    opacity: 1,
  });

  // Fade in texts
  $("#intro p").each($.proxy(function (i, n) {
    this.introToGameTimeline.fromTo(n, 1, {
      opacity: 0,
    }, {
      opacity: 1,
    }, ((i == 0) ? "+=1" : "+=4.5"));
  }, this));

  //
  // this.introToGameTimeline.fromTo($("#intro .text-1"), 1, {
  //   opacity: 0,
  // }, {
  //   opacity: 1,
  // });
  //
  // this.introToGameTimeline.fromTo($("#intro .text-2"), 1, {
  //   opacity: 0,
  // }, {
  //   opacity: 1,
  // }, "+=8");


  // Fade-out after a while
  this.introToGameTimeline.fromTo($("#intro"), 2, {
    autoAlpha: 1,
  }, {
    autoAlpha: 0,
  }, "+=4");

  if (this.baseSceneBlur != 0) {
    this.introToGameTimeline.fromTo([this.vblur.uniforms.radius, this.hblur.uniforms.radius], 1, {
      value: this.baseSceneBlur,
    }, {
      value: 0,
    }, "-=0.5");
  }

  this.introToGameTimeline.fromTo($("#game-1-main-title"), 1, {
    autoAlpha: 0,
  }, {
    autoAlpha: 1,
  }, "-=0.5");

  this.introToGameTimeline.fromTo($("#menu"), 1, {
    autoAlpha: 0,
  }, {
    autoAlpha: 1,
  }, "-=0.5");

  this.introToGameTimeline.fromTo($("#game-1-main-title"), 1, {
    autoAlpha: 0,
  }, {
    autoAlpha: 1,
  }, "-=1");

  this.introToGameTimeline.fromTo($("#screen-1-text-container"), 1, {
    autoAlpha: 0,
  }, {
    autoAlpha: 1,
  }, "-=1");

  this.introToGameTimeline.addCallback(function () {
    $("body").removeClass("intro-shown");
    $("body").addClass("game-shown");
  }, "+=0", [], this);
}

Scenario.prototype.defineTimeline = function () {

  // Main timeline
  this.timeline = new TimelineMax();

  // On update callback
  this.timeline.eventCallback("onUpdate", function () {
    this.lastScrollMillis = millis();
  }, [], this);

  var easing = Linear.easeNone;

  // screen 1 - text
  this.timeline.addLabel("1930");

  this.timeline.to($("#screen-1-progression-line-container .cursor"), 10,
    {
      top: "100%",
      ease: easing
    });

  this.timeline.fromTo($("#screen-1-progression-line-container .surface"), 10, {attr: {"data-value": 1050}}, {
    attr: {"data-value": 605}, onUpdate: function () {
      $("#screen-1-progression-line-container .surface").text(Math.ceil($(".surface").attr("data-value")))
    }
  }, "-=10");

  this.timeline.to(this.sea1ShaderMaterial.uniforms.fadeout, 10,
    {
      value: 1,
      ease: easing
    }, "-=10");

  this.timeline.to(this.s1Mountains.material, 5,
    {
      opacity: 0,
      ease: easing
    }, "-=5");

  // this.timeline.to(this.s1Sea.position, 2,
  // 	{
  // 		y: "-=500"
  // 	}, "-=2");

  this.timeline.to(this.s2GroundSalt.material, 5,
    {
      opacity: 1,
      ease: easing
    }, "-=5");

  this.timeline.to(this.s2House.material, 5,
    {
      opacity: 1,
      ease: easing
    }, "-=5");

  // Hide partners logo
  this.timeline.addCallback(function () {
    $("#partners-logos").addClass("shown");
  }, "-=9.9", [], this).addCallback(function () {
    $("#partners-logos").removeClass("shown");
  }, "-=9.8", [], this);

  // Handle scrolling titles
  this.timeline.addCallback(function () {
    this.revealOnScrollText("1");
  }, "-=9.5", [], this);
  this.timeline.addCallback(function () {
    this.revealOnScrollText("2");
  }, "-=8.5", [], this);
  this.timeline.addCallback(function () {
    this.revealOnScrollText("3");
  }, "-=6.5", [], this);
  this.timeline.addCallback(function () {
    this.revealOnScrollText("4");
  }, "-=4.5", [], this);
  this.timeline.addCallback(function () {
    this.revealOnScrollText("5");
  }, "-=2.5", [], this);


  this.timeline.addLabel("2020");

  // Disable scroll and go automatically to the shimon-house
  this.timeline.addCallback(function () {
    if (this.timeline.isAtShimonHouse) {
      this.app.enableScroll();

    } else {
      this.app.disableScroll();

      if (this.started) {
        $('html, body').animate({
          scrollTop: this.getTimelineLabelPixelPosition("shimon-house-big") // TODO: change this to stop at shimon house when we will have more sections
        }, this.autoZoomToHouseDuration); // TODO: This timing directly represent the auto-zoom duration. Even if we change the values in the timeline below.
      }
    }

    this.timeline.isAtShimonHouse = false;

  }, "+=1", [], this); // add a little pause to let the user side scroll before zooming in


  this.timeline.to([this.scene2OverGroup.scale, this.scene2UnderGroup.scale], 2,
    {
      x: 13,
      y: 13,
      ease: easing
    });

  this.timeline.to([this.scene2OverGroup.position, this.scene2UnderGroup.position], 2,
    {
      y: 1924,
      ease: easing
    }, "-=2");

  this.timeline.to(this.s2Mountains.material, 1.5,
    {
      opacity: 0,
      ease: easing
    }, "-=2");

  this.timeline.to(this.s2GroundSalt.material, 1.5,
    {
      opacity: 0,
      ease: easing
    }, "-=2");

  this.timeline.from(this.s3Montains.scale, 2,
    {
      x: 0.65,
      y: 0.65,
      ease: easing
    }, "-=2");


  this.timeline.to(this.s3House.material, 1.5,
    {
      opacity: 1,
      ease: easing
    }, "-=1.5");


  // Custom Tweenmax added to timeline. It's variable is used below.
  var cameraTween = TweenMax.to(this.camera.position, 1.5,
    {
      x: 0,
      ease: easing,
      onUpdate: this.dragUpdate,
      onUpdateScope: this,
      onUpdateParams: [this.camera.position.x, this.camera.position.y],
    });
  this.timeline.add(cameraTween, "-=1.5");

  // Enable drag when playing backward
  this.timeline.addCallback(function () {
    this.enableDrag();
  }, "-=1.52", [], this);

  // Disable drag when playing forward
  this.timeline.addCallback(function () {
    this.disableDrag();
    cameraTween.invalidate()
  }, "-=1.510", [], this);

  // HOuse fadeout
  this.timeline.to(this.s2House.material, 1,
    {
      opacity: 0,
      ease: easing
    }, "-=1");

  // This is used to allow camera centering when playing backward
  this.timeline.addCallback(function () {
    new TweenMax.set(this.camera.position, {x: 0});
    cameraTween.invalidate()
  }, "-=0", [], this);

  this.timeline.to($("#screen-1-text-container"), 1,
    {
      autoAlpha: 0,
      ease: easing
    }, "-=2");

  this.timeline.to($("#screen-3-text-container"), 1,
    {
      autoAlpha: 1,
      ease: easing
    }, "-=1");

  this.timeline.to(this.s4HoleLayer1.material, 1,
    {
      opacity: 1,
      ease: easing
    }, "+=0.5");

  this.timeline.to(this.s4HoleLayer2.material, 1,
    {
      opacity: 1,
      ease: easing
    }, "-=0.25");

  this.timeline.to(this.s4HoleLayer3.material, 0.15,
    {
      opacity: 1,
      ease: easing
    }, "+=0.5");

  this.timeline.to(this.s4HoleLayer4.material, 0.15,
    {
      opacity: 1,
      ease: easing
    }, "-=0.1");

  this.timeline.to(this.s4HoleLayer5.material, 0.15,
    {
      opacity: 1,
      ease: easing
    }, "-=0.1");

  this.timeline.addLabel("shimon-house-big");


  this.timeline.addCallback(function () {

    if (!this.timeline.isAtShimonHouse) {
      this.app.enableScroll();
    } else {
      this.app.disableScroll();

      if (this.started) {
        $('html, body').animate({
          scrollTop: this.getTimelineLabelPixelPosition("2020") // TODO: change this to stop at shimon house when we will have more sections
        }, this.autoZoomToHouseDuration); // TODO: This timing directly represent the auto-zoom duration. Even if we change the values in the timeline below.
      }

    }

    this.timeline.isAtShimonHouse = true;
  }, '-=0.025', [], this);

}

Scenario.prototype.getTimelineLabelPixelPosition = function (label, offset) {
  if (typeof offset === "undefined") {
    offset = 0;
  }

  if (this.timeline.getLabelTime(label) === -1) {
    console.warn("The label " + label + " doesn't exist.");
    return false;
  }

  return ($("html").height() - window.innerHeight) * ((this.timeline.getLabelTime(label) + offset) / this.timeline.duration());
}

// Scenario.prototype.getTimelineLabelProgressPosition = function (label, offset) {
//   if (typeof offset === "undefined") {
//     offset = 0;
//   }
//   return ((this.timeline.getLabelTime(label) + offset) / this.timeline.duration());
// }


Scenario.prototype.setScroll = function () {
  var numScreens = this.$container.find(".screen").length;
  $("html, body").height((100 * (numScreens * this.app.scrollSpeedFactor)) + "vh");

  // force scroll back up
  $('html, body').animate({
    scrollTop: 0
  }, 10);

  this.app.scrollMagicController = new ScrollMagic.Controller({
    refreshInterval: 0
  });

  this.app.scrollScene = new ScrollMagic.Scene({
    triggerHook: 0,
    duration: $("body").height() - window.innerHeight
  });

  this.app.scrollScene.setTween(this.timeline);

  this.app.scrollScene.addTo(this.app.scrollMagicController);

  // fix bug on show
  setTimeout($.proxy(function () {
    this.app.scrollMagicController.scrollTo(1);
  }, this), 10);

  // this.app.scrollScene.on("progress", function (event) {
  // 	console.log("Scene progress changed to " + event.progress);
  // });

}

Scenario.prototype.linkScrollAndTimeline = function () {

  // force scroll back up
  document.documentElement.scrollTop = 0

  if (this.app.scrollScene) {
    this.app.scrollScene.enabled(true);
  }
}

Scenario.prototype.unlinkScrollAndTimeline = function () {
  if (this.app.scrollScene) {
    this.app.scrollScene.enabled(false);
  }
}

Scenario.prototype.revealOnScrollText = function (id) {
  $("#screen-1-main-title .reveal-on-scoll").each(function (i, n) {
    if ($(n).data("reveal-id") == id) {
      TweenMax.to(n, 0.5,
        {
          autoAlpha: 1,
          y: 0,
          ease: Sine.easeInOut
        });
    } else {
      TweenMax.to(n, 0.5,
        {
          autoAlpha: 0,
          y: 10,
          ease: Sine.easeInOut
        });
    }
  });
}

Scenario.prototype.reset = function () {
  console.log("Calling reset on Scenario");

  $(window).off("resize", $.proxy(this.resize, this)).on("resize", $.proxy(this.resize, this));
  this.resize();

  // TODO: reset starting position etc..
  this.lastScrollMillis = millis();
  this.impetus.setValues(0, 0);
  this.impetusPaused = false;

  // force scroll back up
  $('html, body').animate({
    scrollTop: 0
  }, 10);
}

// Expose Scenario
window.Scenario = Scenario;

